import angular from 'angular';
import invoiceCreateTravelComponent from './invoice-create-travel.component';

let invoiceCreateTravelModule = angular.module('invoiceCreateTravel', [])
  .component('invoiceCreateTravel', invoiceCreateTravelComponent);

export default invoiceCreateTravelModule;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-create-travel/invoice-create-travel.js